export enum MenuApiEnum{
  Menu = 'menu',
  MenuGroup = 'menu-group',
  FoodModule = `foo-m`,
  Food = 'food',
  MenuFood = 'menu-food',
  MenuGroupMenu ='menu-group-menu',
  FoodItemCategory = 'food-category',
  MenuItemOrder = 'menu-item-order',
  Bulk = 'bulk',
}
